// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_UGyc0 {
    display : grid;
    grid-template-columns: auto 1fr;
    column-gap : var( --size-padMedium, 16px );
    row-gap : var( --size-padMedium, 16px );
    align-items: center;
    justify-content: left;
    padding : var( --size-padMedium, 16px );
  }

  .fill_dxEL0 {
    grid-column: 1 / span 2;
  }

  .sub_jagBQ {
    padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
    border-top: 1px solid var( --color-base200 );
    border-bottom: 1px solid var( --color-base200 );
  }

  .editor_e0TBO {
    position: relative;
    min-height: 50vh;
  }

  .list_V3voV {
    min-width : 240px;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/aggregations/shared/AggItemEditor.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,+BAA+B;IAC/B,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qGAAqG;IACrG,4CAA4C;IAC5C,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".grid {\n    display : grid;\n    grid-template-columns: auto 1fr;\n    column-gap : var( --size-padMedium, 16px );\n    row-gap : var( --size-padMedium, 16px );\n    align-items: center;\n    justify-content: left;\n    padding : var( --size-padMedium, 16px );\n  }\n\n  .fill {\n    grid-column: 1 / span 2;\n  }\n\n  .sub {\n    padding : var( --size-padMedium, 16px ) 0 var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n    border-top: 1px solid var( --color-base200 );\n    border-bottom: 1px solid var( --color-base200 );\n  }\n\n  .editor {\n    position: relative;\n    min-height: 50vh;\n  }\n\n  .list {\n    min-width : 240px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_UGyc0`,
	"fill": `fill_dxEL0`,
	"sub": `sub_jagBQ`,
	"editor": `editor_e0TBO`,
	"list": `list_V3voV`
};
export default ___CSS_LOADER_EXPORT___;
